import { datadogRum, DefaultPrivacyLevel } from "@datadog/browser-rum"

let rumInitialized = false

/**
 * Browser RUM via @datadog/browser-rum (no React runtime dependency; compatible with React 17).
 * Application id and client token are public RUM credentials (same for every browser session).
 */
export function initDatadogRum(): void {
  datadogRum.init({
    applicationId: "da5ba399-02f2-48bc-9dcd-35b87e02c056",
    clientToken: "pub25952bfbec97b9b6936af3e0f3544333",
    site: "datadoghq.eu",
    service: "really-not-bootstrap",
    env: import.meta.env.VITE_REACT_APP_ENV || "development",
    version: import.meta.env.VITE_APP_VERSION,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 20,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: DefaultPrivacyLevel.MASK_USER_INPUT,
  })
  rumInitialized = true
}

/**
 * Maps the Redux current user to Datadog RUM user session (`usr.*`).
 * Per Datadog docs, `name` maps to `usr.name` (default label in the RUM UI); if it is missing,
 * the UI shows "Public User" even when `id` and `email` are set.
 * @see https://docs.datadoghq.com/fr/real_user_monitoring/application_monitoring/browser/advanced_configuration/?tab=npm#user-session
 */
export function syncDatadogRumUser(context: {
  id: number
  email: string
  firstName: string
  lastName: string
  typology: string
}): void {
  if (!rumInitialized) {
    return
  }
  const { id, email, firstName, lastName, typology } = context
  if (id === 0 && !email) {
    datadogRum.clearUser()
    return
  }
  const displayName = `${firstName} ${lastName}`.trim()
  const userId = id > 0 ? String(id) : email
  const name = displayName || email || (id > 0 ? String(id) : "")
  datadogRum.setUser({
    id: userId,
    name,
    email: email || undefined,
    typology: typology || undefined,
  })
}
